import React, { useEffect, useState } from 'react';
import { StocksCard } from './InputGroups';
import ELayersView from 'enums/ELayersView';
import {
  compareStockByStockConcen,
  compareStockByStockPh,
  GetFavouriteStocks,
  getIngIngType,
  GetIngredients,
  isNullOrUndefined,
} from 'utils/Global';
import { IngredientStockDTO } from 'business/models/Models';
import SelectSearch from './SelectSearch';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import { ingredientTypesEnum } from './SelectIngredients';

interface SelectStocksProps extends WithTabBackButtonStateProps {
  setContentView: any;
  setSelectStock: any;
  selectIngredient?: any;
  lowPHStocks?: any;
  selectedIngType?: string;
  handleBackToPreviousScreen?: (contentView: ELayersView) => () => void;
}

function SelectStocks(props: SelectStocksProps) {
  const {
    setContentView,
    setSelectStock,
    selectIngredient,
    lowPHStocks,
    selectedIngType = ingredientTypesEnum.All,
    handleBackToPreviousScreen,
    setHandleOnTabBackPress,
  } = props;
  const [selectValue, setSelectValue] = useState(selectedIngType);
  const [stocksArray, setStocksArray] = useState<IngredientStockDTO[]>([]);
  const [searchStock, setSearchStock] = useState('');
  const [filteredStock, setFilteredStock] = useState([]);
  const [globalFavIngStocks, setGlobalFavIngStocks] = useState([]);
  const ingIngType = getIngIngType(selectIngredient.id);
  useEffect(() => {
    let stocks: IngredientStockDTO[] = [];
    if (isNullOrUndefined(lowPHStocks)) {
      stocks = GetIngredients().ingredientStock.filter(
        (ingStock) => ingStock.ingredientId === ingIngType.ingredientId,
      );
    } else {
      stocks = GetIngredients().ingredientStock.filter(
        (ingStock) =>
          ingStock.ingredientId === ingIngType.ingredientId &&
          ingStock.isBuffer === lowPHStocks.isBuffer &&
          ingStock.stockPh >= lowPHStocks.stockPh &&
          ingStock.stockConcentration === lowPHStocks.stockConcentration,
      );
    }

    setStocksArray([...stocks.sort((a, b) => a.stockPh - b.stockPh)]);
  }, [selectIngredient]);

  useEffect(() => {
    filterStocks(stocksArray);
  }, [searchStock, stocksArray, selectValue]);

  useEffect(() => {
    if (handleBackToPreviousScreen) {
      setHandleOnTabBackPress(() =>
        handleBackToPreviousScreen(ELayersView.SELECTINGREDIENTSVIEW),
      );
    }
  }, [setHandleOnTabBackPress]);

  useEffect(() => {
    setGlobalFavIngStocks(GetFavouriteStocks());
  }, []);

  function filterStocks(stocks) {
    let filterStock: IngredientStockDTO[] = stocks;
    let tempStock: IngredientStockDTO[] = filterStock.filter((stock) => stock.active);
    switch (selectValue) {
      case ingredientTypesEnum.NonBuffer:
        filterStock = stocks.filter((stock) => !stock.isBuffer);
        tempStock = filterStock.sort(compareStockByStockConcen);
        break;
      case ingredientTypesEnum.Buffer:
        filterStock = stocks.filter((stock) => stock.isBuffer);
        tempStock = filterStock.sort(compareStockByStockPh);
        break;
      case ingredientTypesEnum.Prepared:
        filterStock = stocks.filter((stock) => stock.isPrepared);
        tempStock = filterStock.sort(compareStockByStockConcen);
        break;
      default:
        break;
    }
    setFilteredStock(
      tempStock.filter((stock) => {
        return isNullOrUndefined(stock?.vendor)
          ? true
          : stock?.vendor?.name?.toLowerCase()?.includes(searchStock) ||
              stock.vendorPartNumber?.toLowerCase()?.includes(searchStock);
      }),
    );
  }

  function changeSearchStock(e) {
    setSearchStock(e.target.value.toLowerCase());
  }
  function onSelectStocks(stock: IngredientStockDTO) {
    setSelectStock(stock);
    setContentView(ELayersView.EDITINGREDIENTSVIEW);
  }
  if (isNullOrUndefined(stocksArray) || stocksArray.length === 0) {
    return null;
  }
  return (
    <div id="selectstocks-wrapper"  style={{ height: '100%' }}>
      <SelectSearch
        selectValue={selectValue}
        setSelectValue={setSelectValue}
        placeHolder="Search Stocks"
        searchValue={searchStock}
        changeSearch={changeSearchStock}
      />
      <div id="selectstocks-list" className="stocks-container">
        {filteredStock.map((stock) => (
          <StocksCard
            stockData={stock}
            isFavourite={globalFavIngStocks?.some(
              (stk) => stk.ingredientStockId === stock.id,
            )}
            key={stock.id}
            onClick={() => onSelectStocks(stock)}
            setGlobalFavIngStocks={setGlobalFavIngStocks}
          />
        ))}
      </div>
    </div>
  );
}

export default withTabBackButton(SelectStocks);
